import { toBase64 } from './utils';

export const sendToAssistant = async (apiEndpoint, requestPayload) => {
    const { text, attachments, status, deviceConfig } = requestPayload;
    const { file, image, audio } = attachments || {};

    const requestData = {
        ...deviceConfig,
        Text: text || "",
        Audio: audio ? await toBase64(audio) : "",
        Image: image ? await toBase64(image) : "",
        File: file ? await toBase64(file) : "",
        Status: status
    };

    try {
        const response = await fetch(`${apiEndpoint}?t=${Date.now()}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                ...(deviceConfig.SessionID && { 'Authorization': `Bearer ${deviceConfig.SessionID}` })
            },
            body: JSON.stringify(requestData),
            cache: "no-store"
        });

        if (!response.ok) {
            throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error en la solicitud:', error);
        throw error;
    }
};

// Obtiene la lista de todas las conversaciones para un dispositivo
export const fetchConversations = async (deviceId) => {
    try {
        //const response = await fetch(`http://127.0.0.1:5000/api/Scraping/history/device/${encodeURIComponent(deviceId)}`);
        const response = await fetch(`https://ai.wdi.net/api/Scraping/history/device/${encodeURIComponent(deviceId)}`);
        if (!response.ok) {
            throw new Error("Error obteniendo conversaciones");
        }
        return await response.json();
    } catch (err) {
        console.error("Error cargando conversaciones:", err);
        throw err;
    }
};

// Carga los mensajes de un chat específico
export const handleChatClick = async (deviceId, url) => {
    try {
        //const response = await fetch("http://127.0.0.1:5000/api/Scraping/history/device/url", {
        const response = await fetch("https://ai.wdi.net/api/Scraping/history/device/url", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                iddevice: deviceId,
                url: url,
            }),
        });
        if (!response.ok) {
            throw new Error("Error al hacer clic en el chat");
        }
        return await response.json();
    } catch (error) {
        console.error("Error cargando chat:", error);
        throw error;
    }
};